var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-checkbox-group',{attrs:{"options":_vm.options},on:{"change":_vm.onChange},model:{value:(_vm.changeValue),callback:function ($$v) {_vm.changeValue=$$v},expression:"changeValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }